import { PropTypes } from 'prop-types';
import { React, useCallback, useRef, useState } from 'react';
import { Button, Popover } from '@decisiv/ui-components';
import { Menu } from '@decisiv/ui-components/lib/components';
import iconix from '@decisiv/iconix/lib/components';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import { t, Trans } from '@lingui/macro';

export default function TriggerTypesMenu({
  integration,
  onSelectTriggerType,
  selectedTriggerType,
  disableTriggerType,
}) {
  // eslint-disable-next-line no-unused-vars
  const [menu, setMenu] = useState();

  const popRef = useRef();
  const setMenuRef = useCallback(setMenu);

  const mountPossibleTriggerTypes = () => {
    const triggerTypes = [];

    if (integration?.attributes?.trigger_type?.includes('http_api_request')) {
      triggerTypes.push({
        id: '1',
        text: 'http',
      });
    }

    if (integration?.attributes?.trigger_type?.includes('application_event')) {
      integration?.attributes?.events.map((value, i) =>
        triggerTypes.push({
          id: String(i + 2),
          text: value,
        }),
      );
    }

    return triggerTypes;
  };

  const items = mountPossibleTriggerTypes();

  const assignRefs = (setTargetRef, node) => {
    // eslint-disable-next-line no-unused-expressions
    setTargetRef && setTargetRef(node);
  };

  const localSelectTriggerType = (e) => {
    popRef.current.hide();
    onSelectTriggerType(e);
  };

  const target = ({ ref, ariaAttributes, toggle, isVisible }) => (
    <Flex>
      <Trans>Type: </Trans>
      <Button
        ref={(node) => assignRefs(ref, node)}
        text={selectedTriggerType}
        aria-label={t`Trigger type`}
        icon={isVisible ? iconix.ChevronUp : iconix.ChevronDown}
        onClick={toggle}
        iconPosition="right"
        variant="ghost"
        disabled={disableTriggerType}
        style={{
          paddingBottom: '15px',
        }}
        {...ariaAttributes}
      />
    </Flex>
  );

  return (
    <Popover ref={popRef} target={target} contentRole="menu">
      <Menu
        ref={setMenuRef}
        items={items}
        onSelectItem={localSelectTriggerType}
      />
    </Popover>
  );
}

TriggerTypesMenu.propTypes = {
  integration: PropTypes.oneOfType([PropTypes.object]).isRequired,
  onSelectTriggerType: PropTypes.func.isRequired,
  selectedTriggerType: PropTypes.string.isRequired,
  disableTriggerType: PropTypes.bool.isRequired,
};
